export default {"src":"/_next/static/media/Oops.d2859d53.svg","height":375,"width":501,"blurWidth":0,"blurHeight":0};